import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FilePlus } from 'lucide-react';

export default function CreditHeader() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Dashboard Analisis Kredit</h1>
        <p className="text-gray-500 mt-1">Monitor dan analisis aplikasi kredit</p>
      </div>
      <button
        onClick={() => navigate('/credit/new')}
        className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
      >
        <FilePlus className="w-4 h-4" />
        Pengajuan Kredit Baru
      </button>
    </div>
  );
}
